<div  class="container-fluid container-background">
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">
            <div class="outer">
                <div class="middle">
                
                    <div class="login-form-container">
                        <div class="login-header-title">
                            <i class="zmdi zmdi-lock zdmi-fw"></i>
                            Verify your email
                        </div>
                        <sync-error [errcode]="errcode"></sync-error>
                        <p *ngIf="spinner">
                            <i class="fa fa-spin fa-spinner"></i>
                            Verifying code...
                        </p>

                        <div *ngIf="errcode">
                            <p>Enter manually:</p>

                            <form class="form-inline" ngNativeValidate>
                            <div class="form-group">
                               <input type="text" class="form-control" [(ngModel)]="confirmcode" [ngModelOptions]="{standalone: true}" />
                            </div>
 
                            <button (click)="verify()" class="btn btn-default">Submit</button>
                            </form>

                            <hr />
                            <button
                                *ngIf="authenticated"
                                class="btn btn-default"
                                (click)="resendVerification()"
                            >
                                Resend verification code
                            </button>

                            <button
                                *ngIf="!authenticated"
                                class="btn btn-default"
                                routerLink="/login"
                            >Log in to resend your verification code</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
